import React from "react";
import PropTypes from "prop-types";
//Material imports
import { ThemeProvider } from "@mui/material/styles";
// limitless imports
import TooltipButton from "../../../buttons/tooltip-button/TooltipButton";
import { useExpertMessageContext } from "../../../../../expert/hooks/expert-message/ExpertMessageContext";
import ConversationPanelContainer from "../conversation-panel-container/ConversationPanelContainer";
import { CLAIMED_FOR_RESPONSE_DURING_REVIEW } from "../../../../utils";
import { useExpertProfileContext } from "../../../../../expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
const ConversationPanelFooter = ({
  isCancelDisabled,
  isFinishDisabled,
  finishTooltip,
  cancelTooltip,
  onFinish
}) => {
  const {
    message,
    cancelEditingMessage,
    cancelEditingReviewMessage,
    finishEditingMessage
  } = useExpertMessageContext();
  const [isloading, setIsloading] = React.useState(false);
  const {
    isDarkMode
  } = useExpertProfileContext();
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  const isEditingDuringReview = message.conversationState.state === CLAIMED_FOR_RESPONSE_DURING_REVIEW;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ConversationPanelContainer, {
    gutterTop: true
  }, /*#__PURE__*/React.createElement(TooltipButton, {
    tooltipTitle: isCancelDisabled ? cancelTooltip : "",
    placement: "top",
    buttonProps: {
      id: "cancelButton",
      variant: "text",
      disabled: isCancelDisabled || isloading,
      size: "small"
    },
    onClick: () => {
      setIsloading(true);
      isEditingDuringReview ? cancelEditingReviewMessage() : cancelEditingMessage();
    },
    allowButtonClasses: false
  }, isEditingDuringReview ? "Back to Review" : "Cancel"), /*#__PURE__*/React.createElement(TooltipButton, {
    tooltipTitle: isFinishDisabled ? finishTooltip : "",
    placement: "top",
    buttonProps: {
      id: "finishButton",
      variant: "contained",
      disabled: isFinishDisabled,
      size: "small"
    },
    onClick: onFinish || finishEditingMessage,
    allowButtonClasses: false
  }, "Finish")));
};
export default ConversationPanelFooter;
ConversationPanelFooter.propTypes = {
  loading: PropTypes.bool,
  isCancelDisabled: PropTypes.bool,
  isFinishDisabled: PropTypes.bool.isRequired,
  finishTooltip: PropTypes.string,
  cancelTooltip: PropTypes.string,
  onFinish: PropTypes.func
};